import React from 'react'
import styled from 'styled-components'
import { Color, Size } from '../../../../../const'
import { Button } from '../../../../shard'
import WrapperLink from 'components/shard/WrapperLink'

function IdEdit() {
  return (
    <Content>
      <TextArea>
        <Text>
          ID変更が完了しました。
          <br />
          新しいIDで再度ログインしてください。
        </Text>
      </TextArea>
      <ButtonWrapper>
        <NextLink to="/login" rel="noopener noreferrer">
          <Button type="button" primary>
            ログインする
          </Button>
        </NextLink>
      </ButtonWrapper>
    </Content>
  )
}

const Content = styled.div`
  padding: 38px 0 90px;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
`
const TextArea = styled.div`
  padding-bottom: 71px;
  display: flex;
  justify-content: center;
`
const Text = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  width: 335px;
  text-align: center;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`
const NextLink = styled(WrapperLink)`
  text-decoration: none;
`

export default IdEdit
